import { render, staticRenderFns } from "./AMultipleUrls.vue?vue&type=template&id=8efce456&"
import script from "./AMultipleUrls.vue?vue&type=script&lang=js&"
export * from "./AMultipleUrls.vue?vue&type=script&lang=js&"
import style0 from "./AMultipleUrls.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports